export const GET_MY_CIRCLE_LIST = 'GET_MY_CIRCLE_LIST'
export const GET_MY_JOINED_CIRCLE_LIST = 'GET_MY_JOINED_CIRCLE_LIST'
export const GET_MY_CIRCLE_LIST_RESULT = 'GET_MY_CIRCLE_LIST_RESULT'
export const GET_MY_JOINED_CIRCLE_LIST_RESULT = 'GET_MY_JOINED_CIRCLE_LIST_RESULT'

export const CIRCLE_LOAD_START = 'CIRCLE_LOAD_START'
export const CIRCLE_LOAD_END = 'CIRCLE_LOAD_END'


// WEBPACK FOOTER //
// ./src/constants/User/CircleList.js